export default {
  title: 'Pedido anticipado',
  categories: {
    title: 'Más populares',
  },
  header: {
    pickup: 'Recogida en 5 minutos',
  },
};
